<template>
  <div>
    <template v-if="variantDataLoaded">
      <rfp-mctb-provider
        :buy-now="buyNow"
        :carousel-header="carouselHeader"
        :buynow-data="buynowData"
        :buy-online-button-text="buyOnlineButtonText"
        :buy-offline-button-text="buyOfflineButtonText"
        :star-inactive-color="starInactiveColor"
        :star-active-color="starActiveColor"
        :star-size="starSize"
        :enable-rtl="enableRtl"
        :component-diffs="true"
        :retailer-unavailable="retailerUnavailable"
        :a11y="a11y"
      >
      </rfp-mctb-provider>
    </template>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import globalMixin from './global-mixin';
import RfpMctbProvider from './rfp-mctb-provider.vue';

export default {
  name: 'rfp-mctb-has-variant',
  components: {
    RfpMctbProvider,
  },
  mixins: [globalMixin],
  props: {
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      default: 'Header Text',
    },
    buyNow: {
      type: String,
      default: 'Buy Now',
    },
    starInactiveColor: {
      type: String,
      default: '#000',
    },
    starActiveColor: {
      type: String,
      default: '#f00',
    },
    starSize: {
      type: Number,
      default: 25,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    retailerUnavailable: {
      type: String,
      default: 'unfortunatly no retailers are available at this moment.',
    },
    a11y: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    eventBus.emit('rfp-mctb-has-variant-component1');
  },
};
</script>
